import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadingActions } from 'modules/loading';
import { useDispatch } from 'react-redux';
import { ROUTE_PATH } from 'routes';
import './styles.scss';

const widgetCode = 'siq860890dc970c4dab9db1ff24cc83501683c3ec7a69af5fb2e47432e1a522b4fd';

const Chat = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadingActions.show());
    setTimeout(() => {
      dispatch(loadingActions.hide());
    }, 1000);

    // Sale de /chat de forma segura: hace back si hay historial previo en la
    // SPA, o va al home si /chat es la primera entrada (deep-link / refresh).
    const goBack = () => {
      if (window.history.state && window.history.state.idx > 0) {
        navigate(-1);
      } else {
        navigate(ROUTE_PATH.HOME);
      }
    };

    // Configura la visibilidad del widget y re-registra el callback de
    // minimizar. Debe ejecutarse en cada montaje de /chat (no solo en la
    // primera carga) para que el back siga funcionando en visitas posteriores.
    const showAndBind = () => {
      window.$zoho.salesiq.chatbutton.visible('hide');
      window.$zoho.salesiq.floatbutton.visible('hide');
      window.$zoho.salesiq.floatbutton.coin.hidetooltip();
      window.$zoho.salesiq.floatwindow.visible('show');
      window.$zoho.salesiq.floatwindow.minimize(goBack);
    };

    if (window.$zoho) {
      showAndBind();
    } else {
      // Crea un script y añade los atributos correspondientes
      const script = document.createElement('script');
      script.src = 'https://salesiq.zohopublic.com/widget';
      script.defer = true;
      script.id = 'zsiqscript';

      window.$zoho = window.$zoho || {};
      window.$zoho.salesiq = window.$zoho.salesiq || {
        widgetcode: widgetCode,
        values: {},
      };

      window.$zoho.salesiq.ready = showAndBind;

      document.body.appendChild(script);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default Chat;
